import React, { useEffect, useState } from 'react'
import Navbar from '../nav/Navbar';
import Footer from '../footer/Footer'

function Declaration() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Detect dark mode preference
  const [isDarkMode, setIsDarkMode] = useState(false);

  useEffect(() => {
    // Check if user prefers dark mode
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    setIsDarkMode(mediaQuery.matches);

    // Listen for changes
    const handleChange = (e) => setIsDarkMode(e.matches);
    mediaQuery.addEventListener('change', handleChange);

    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  const styles = {
    container: {
      fontFamily: 'Arial, sans-serif',
      lineHeight: '1.6',
      color: isDarkMode ? '#e0e0e0' : '#333',
      maxWidth: '800px',
      margin: '0 auto',
      padding: '40px 20px',
      backgroundColor: isDarkMode ? '#1a1a1a' : 'transparent',
      minHeight: 'calc(100vh - 200px)'
    },
    heading: {
      textAlign: 'center',
      color: isDarkMode ? '#ffffff' : '#2c3e50',
      marginBottom: '30px',
      borderBottom: `2px solid ${isDarkMode ? '#4a90e2' : '#3498db'}`,
      paddingBottom: '15px',
      fontSize: '2.5rem',
      fontWeight: 'bold'
    },
    content: {
      backgroundColor: isDarkMode ? '#2d2d2d' : '#f8f9fa',
      padding: '30px',
      borderRadius: '10px',
      borderLeft: `4px solid ${isDarkMode ? '#4a90e2' : '#3498db'}`,
      boxShadow: isDarkMode ? '0 4px 6px rgba(0, 0, 0, 0.3)' : '0 4px 6px rgba(0, 0, 0, 0.1)',
      fontSize: '16px',
      textAlign: 'justify'
    },
    paragraph: {
      marginBottom: '20px',
      color: isDarkMode ? '#e0e0e0' : '#333',
      fontSize: '16px',
      lineHeight: '1.8'
    },
    highlight: {
      color: isDarkMode ? '#4a90e2' : '#2980b9',
      fontWeight: 'bold'
    },
    fadeIn: {
      animation: 'fadeIn 0.8s ease-in'
    }
  };

  // Add CSS animation for fadeIn
  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      @keyframes fadeIn {
        from {
          opacity: 0;
          transform: translateY(20px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <div style={{ backgroundColor: isDarkMode ? '#1a1a1a' : 'transparent', minHeight: '100vh' }}>
      <Navbar />
      <div style={{...styles.container, ...styles.fadeIn}}>
        <h1 style={styles.heading}>Declaration</h1>
        <div style={styles.content}>
          <p style={styles.paragraph}>
            By expressing your intention to proceed and making payment towards the file logging/processing fee, you confirm that you have been informed, and you consent, to our obtaining your KYC documents and credit bureau reports (CICs) from the concerned authorities. You also permit us to record our communications with you, and to securely retain such records for preliminary verification, regulatory compliance, and any future correspondence, as may be required.
          </p>
          
          <p style={styles.paragraph}>
            <strong style={styles.highlight}>हिन्दी में:</strong>
            <br />
            यदि आप आगे बढ़ने की इच्छा जताते हैं और फ़ाइल लॉगिंग/प्रोसेसिंग शुल्क का भुगतान करते हैं, तो इसका मतलब है कि आपको सूचित कर दिया गया है और आप इस बात के लिए सहमति देते हैं कि हम आपके KYC दस्तावेज़ और क्रेडिट ब्यूरो रिपोर्ट (CICs) संबंधित प्राधिकरणों से प्राप्त कर सकते हैं। साथ ही, आप हमें यह अनुमति देते हैं कि हम आपके साथ की गई बातचीत को रिकॉर्ड करें और उन्हें सुरक्षित रूप से संग्रहित करें, ताकि शुरुआती जांच, कानूनी आवश्यकताओं और भविष्य में किसी भी प्रकार के संवाद के लिए उनका उपयोग किया जा सके।
          </p>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default Declaration